export default __webpack_public_path__ + "static/sweepstakes-prize-04-67207dff84b36ccf9d814f1a523be46b.jpg";